import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Icon48Childcare, Icon24Pay, Icon24Star } from '@care/react-embrace-icons';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { useResponsive } from '@/components/hooks/useResponsive';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { narrowSegmentationStats } from '@/helpers/narrowSegmentationStats';

export const CaregiverStats = () => {
  const { avgPayRate, totalNumberOfResults, segmentNamePluralLowerCase } = usePageAttributes();
  const { seoSegmentationStats } = useSearchDirectoryData();
  const { isMediumViewport } = useResponsive();

  const segmentationStats = narrowSegmentationStats(seoSegmentationStats);
  const avgReviewRating = segmentationStats?.avgReviewRating ?? null;
  const monthYear = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });

  const stats = [
    {
      Icon: Icon48Childcare,
      label: `${totalNumberOfResults?.toLocaleString()} ${segmentNamePluralLowerCase} are listed on Care.com`,
      shouldSkipRender: !!totalNumberOfResults,
    },
    {
      Icon: Icon24Pay,
      label: `The average post rate is ${avgPayRate}/hr as of ${monthYear}`,
      shouldSkipRender: !!avgPayRate,
    },
    {
      Icon: Icon24Star,
      label: `The average star rating for rated ${segmentNamePluralLowerCase} is ${avgReviewRating?.toFixed(1)}`,
      shouldSkipRender: !!avgReviewRating,
    },
  ];
  return (
    <List
      sx={{
        maxWidth: { xs: '300px', sm: '100%' },
        display: { xs: 'block', sm: 'flex', md: 'block' },
        mt: { xs: 4, md: 0 },
      }}>
      {stats.map(
        ({ Icon, label, shouldSkipRender }) =>
          shouldSkipRender && (
            <ListItem
              disableGutters
              sx={{
                py: 0,
                mx: { xs: 3, sm: 0, md: 0 },
                mt: { xs: 2, sm: 0, md: 2 },
                mr: { xs: undefined, sm: 4, md: undefined },
                '&:first-of-type': { mt: 0 },
              }}
              key={label}>
              <ListItemAvatar sx={{ mr: { xs: 3, sm: 2, md: 3 } }}>
                <Avatar
                  sx={{
                    bgcolor: 'background.accent.accent3',
                    height: '64px',
                    width: '64px',
                  }}>
                  <Icon size="48px" color="text.primary" />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                secondaryTypographyProps={{
                  color: 'text.primary',
                  variant: isMediumViewport ? 'body3' : 'body2',
                }}
                secondary={label}
              />
            </ListItem>
          )
      )}
    </List>
  );
};
